import React, {useEffect} from 'react';
import {Helmet} from "react-helmet";
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
import {Actions as PAYMENTACTIONS} from '../store/actions/paymentActions';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import BestPriceCalculator from '../components/common/BestPriceCalculator'
import EasyToFollowPricing from '../components/pricing/EasyToFollowPricing'
import PricingTable from '../components/pricing/PricingTable'
import PricingMonthly from '../components/pricing/PricingMonthly'
import PricingFaq from '../components/pricing/PricingFaq'
import Team from '../components/team/Team'
import Testimonials from '../components/testimonials/Testimonials'
import Security from '../components/security/Security'


import MaltaFlag from '../assets/flags/malta.svg';

import mcDonaldsLogo from '../assets/images/mc-donalds.png';
import sixteenLogo from '../assets/images/sixteen.png';
import myokaLogo from '../assets/images/myoka.png';
import skySpiritLogo from '../assets/images/sky-spirit.png';
import SeoHeaders from "../components/SeoHeaders";



function Pricing({
  getBundles,
  bundles,
  faqs
}) {

  useEffect(() => {
    getBundles()
  },[]);

  useEffect(() => {
    
  },[bundles]);


  return (

    <React.Fragment>
      <Helmet>
        <title>Payroll Software Pricing | Buddy</title>
        <meta name="description" content="Buddy's credit-based system ensures fair pricing and that your payroll scales alongside your team. " />
        <link rel="canonical" href={`https://www.buddy.hr/pricing`} />
      </Helmet>

      <SeoHeaders
          title={"Payroll Software Pricing [country] | Leave Management Pricing | Buddy"}
          description={"Payroll Software Pricing for Businesses empowering [country] compliant payroll with pay as you go pricing."}
      />

      <PricingMonthly/>
      <PricingFaq faqs={faqs}/>
      {/*<main className="mt-8 sm:mt-16 md:mt-20 lg:mb-24 mb-8 sm:mb-16 md:mb-20 lg:mb-24">



        <div className="mx-auto max-w-screen-xl">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
              <div>
                <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                  Simple no-tricks
                  <br />
                  <span className="text-orange-400">pricing</span>
                </h1>
                <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                  Buddy's credit-based system ensures that your payroll scales alongside your team. Each credit is worth €2 and is consumed when a new payslip is generated.
                </p>
                <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                  Gain extra bonus credits when purchasing bundles.
                </p>
                <p className="mt-8 text-sm text-white uppercase tracking-wide font-semibold sm:mt-10">Used by</p>
                <div className="mt-5 w-full sm:mx-auto sm:max-w-lg lg:ml-0">
                  <div className="flex flex-wrap items-start justify-between">
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={sixteenLogo} alt="Sixteen Ltd"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={myokaLogo} alt="Myoka Spas"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={skySpiritLogo} alt="Sky Spirit"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-span-6">
              <BestPriceCalculator/>
            </div>
          </div>
        </div>
      </main>

      <EasyToFollowPricing/>
      <PricingTable/>*/}

    </React.Fragment>
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  const faqs = [
    {
      id: 1,
      question: "What's an Active Employee?",
      answer:
        "An active employee is defined as a) a Full Time Employee or b) a Part-Time or Contracted Employee that in a given month has had either of following created: Payslip with a value larger than 0, a timesheet entry or a leave entry.",
    },
    {
      id: 3,
      question: "Can I run payroll with the Starter plan?",
      answer:
        "No payroll is only available on the higher-tier plans. If you do not have in-house payroll expertise, we generally recommend working with one of our partners. However if you work with a partner, you will be able to view and access any payslips that they make available via Buddy.",
    },
    {
      id: 4,
      question: "What customer support is included?",
      answer:
        "Within all three plans we include system support free of charge via Chat and Email. Payroll knowledge queries are not included in our free support. We provide detailed user-guides filled with payroll specific knowledge, a detailed payroll guide as well as the option to undertake payroll courses. While our payroll solution will try to keep you in safe boundaries, we recommend speaking to a specialist if you need tax or payroll advise.",
    },
    {
      id: 5,
      question: "I work with an Accountant/Advisor, do I need to buy my own package?",
      answer:
        "Accountants and Payroll Bureau purchase a payroll software license for internal use, this does not cover/include access for business owners and employees. However we do find that collaboration is ideal, hence why we extend the option to purchase an additional license to link your organisation to the account used by your service provider.",
    },
    {
      id: 6,
      question: "When will my card be charged?",
      answer:
        "No up-front commitment is required, and you can safely use the demo account to try out Buddy. Once you have employees set up on a live account, an email notification is sent on the 20th of the month, with your card charged on the 24th. If you need any clarification or extension to your demo, reach out to our support.",
    },
    {
      id: 6,
      question: "What if there's a problem charging my card?",
      answer:
        "If there's a problem charging your card, we will notify you via email. We will try to charge your card another 3 times, after which your account will be suspended. If you need any clarification.",
    },
    {
      id: 6,
      question: "Can I pay using a Bank Transfer?",
      answer:
        "Yes, each business is given a unique payment reference, which is used to automatically allocate funds into your account. if there are prepayments/overpayments we will hold these funds on account. You can find this reference in the Billing section of your account. No refunds are processed for prepayments/overpayments.",
    },
    {
      id: 6,
      question: "Can I get help to setup my account?",
      answer:
        "Our team offers training and onboarding assistance, including data migration from other solutions. If you're stuck and need a hand to get going, schedule a time to speak to us. Training and Onboarding costs start from €300 + VAT and may vary based on volume of data transfer required. Kindly note that limited slots are available per month.",
    },
    {
      id: 6,
      question: "I'm an accountant / payroll bureau, do I also pay these fees?",
      answer:
        "The above listed fees are specifically for direct clients. While you are free to use any of these plans, we do have Bureau-friendly packages, for those interested in becoming a partner. In addition to the Bureau-friendly packages, becoming a partner also provides access to additional tools to help grow your practice. Get in touch for more details.",
    },
    {
      id: 7,
      question: "Can I perform payroll retroactively?",
      answer:
        "Yes! If you need to catch-up and get your tax documents in order, you can perform payroll for previous months and years. It should be noted that the month of activity is based on the period in which it is relative to, and not the date in which that action is done. Therefore, retroactive actions may still be charged; such as performing January to December payroll in December will count as 12 months of activity.",
    },
    // More questions...
  ]



  return {
    bundles: state.payment.bundles,
    faqs,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  getBundles: () => dispatch(PAYMENTACTIONS.getBundles()),
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Pricing) 
